import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const ArrowIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <SvgIcon width={width} height={height} viewBox={[0, 0, width, height].join(' ')} fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 7.5L18.7604 15.3906C19.2083 16.0624 19.2083 16.9376 18.7604 17.6094L13.5 25.5"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
};
